<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('vitalSigns.title') }}</div>
                    </van-col>
                    <van-col span="6" @click="toVitalSignsRange"><img class="right-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/32vitalSigns/01more.svg`)">
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="chart-box-out">
            <div class="chart-title">
                <div class="chart-title-left">
                    <img src="@/assets/theme/light/status/26recovery/02hr.svg">
                    <div class="chart-title-text">{{ $t('vitalSigns.heartRate') }}</div>
                </div>
                <img @click="toHr" class="chart-to" :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div class="tooltip-box">
                <div class="tooltip-time">{{ tooltipTime }}</div>
                <div class="tooltip-value">{{ tooltipValue }}<span class="tooltip-unit">{{ $t('vitalSigns.unitBpm') }}</span></div>
                <div class="tooltip-safe" v-if="tooltipValue && tooltipValue >= 60 && tooltipValue <= 100">{{ $t('vitalSigns.within') }}60-100</div>
                <div class="tooltip-unsafe" v-else-if="tooltipValue && (tooltipValue < 60 || tooltipValue > 100)">{{ $t('vitalSigns.outside') }}60-100</div>
                <div class="tooltip-none" v-else></div>
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="sign-line">
            <div class="sign-item-box">
                <div class="chart-title-left">
                    <img src="@/assets/theme/light/status/32vitalSigns/02restingHr.svg">
                    <div class="chart-title-text">{{ $t('vitalSigns.restingHr') }}</div>
                </div>
                <div class="tooltip-value">{{ info.hrDeepAvg || '--' }}<span class="tooltip-unit">{{ $t('vitalSigns.unitBpm') }}</span></div>
                <div class="tooltip-safe" v-if="info.hrDeepAvg && info.hrDeepAvg >= 50 && info.hrDeepAvg <= 80">{{ $t('vitalSigns.within') }}50-80</div>
                <div class="tooltip-unsafe" v-if="info.hrDeepAvg && (info.hrDeepAvg < 50 || info.hrDeepAvg > 80)">{{ $t('vitalSigns.outside') }}50-80</div>
            </div>
            <div class="sign-item-box">
                <div class="chart-title-left">
                    <img src="@/assets/theme/light/status/32vitalSigns/03hrv.svg">
                    <div class="chart-title-text">{{ $t('vitalSigns.hrv') }}</div>
                </div>
                <div class="tooltip-value">{{ info.hrvAvg || '--' }}<span class="tooltip-unit">{{ $t('vitalSigns.unitMs') }}</span></div>
                <div class="tooltip-safe" v-if="info.hrvAvg && info.hrvAvg >= 20 && info.hrvAvg <= 70">{{ $t('vitalSigns.within') }}20-70</div>
                <div class="tooltip-unsafe" v-if="info.hrvAvg && (info.hrvAvg < 20 || info.hrvAvg > 70)">{{ $t('vitalSigns.outside') }}20-70</div>
            </div>
        </div>
        <div class="sign-line">
            <div class="sign-item-box">
                <div class="chart-title-left">
                    <img src="@/assets/theme/light/status/32vitalSigns/04bos.svg">
                    <div class="chart-title-text">{{ $t('vitalSigns.spo2') }}</div>
                </div>
                <div class="tooltip-value">--<span class="tooltip-unit">{{ $t('vitalSigns.unitPercent') }}</span></div>
            </div>
            <div class="sign-item-box">
                <div class="chart-title-left">
                    <img src="@/assets/theme/light/status/32vitalSigns/05respRate.svg">
                    <div class="chart-title-text">{{ $t('vitalSigns.respRate') }}</div>
                </div>
                <div class="tooltip-value">{{ info.respRateDeepAvg || '--' }}<span class="tooltip-unit">{{ $t('vitalSigns.unitBrMin') }}</span></div>
                <div class="tooltip-safe" v-if="info.respRateDeepAvg && info.respRateDeepAvg >= 12 && info.respRateDeepAvg <= 20">{{ $t('vitalSigns.within') }}12-20</div>
                <div class="tooltip-unsafe" v-if="info.respRateDeepAvg && (info.respRateDeepAvg < 12 || info.respRateDeepAvg > 20)">{{ $t('vitalSigns.outside') }}12-20</div>
            </div>
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";
import {getQueryVariable, getSkin} from "../../utils/comment";
import {GetDateStr} from "../../utils/dateUtils";

export default {
    name: '32vitalSigns',
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            myChart: null,
            info: {},
            tooltipTime: '',
            tooltipValue: 0,
        }
    },
    mounted() {
        this.getVitalSignsByData();
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        toVitalSignsRange() {
            this.$router.push({
                name: 'vitalSignsRange',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        toHr() {
            this.$router.push({
                name: 'hr',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        getVitalSignsByData() {
            this.$api.status.getVitalSignsByData({
                date: GetDateStr(0)
            }).then(res => {
                this.info = res.info;
                this.$nextTick(function () {
                    this.drawDayChart()
                    this.$forceUpdate()
                })
            })
        },
        updateTooltip(value, time) {
            this.tooltipValue = value;
            this.tooltipTime = time;
        },
        drawDayChart() {
            if (!this.myChart) {
                this.myChart = this.$echarts.init(document.getElementById("chart-box"));
            }
            if (!this.info.hrDeepAvg) {
                this.myChart.setOption({
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 76 * this.ratio,
                        textStyle: {
                            fontFamily: 'SF',
                            fontSize: '12',
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            interval: 35,
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        axisLabel: false,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        }
                    },
                    series: [
                        {
                            data: [0, 0, 0],
                            type: 'bar',
                            symbol: 'none',
                            smooth: false,
                            barWidth: 10,
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            } else {
                this.myChart.setOption({
                    grid: {
                        top: 25 * this.ratio,
                        bottom: 47 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'transparent',
                        borderColor: 'transparent',
                        borderWidth: 0,
                        padding: 0,
                        formatter: function () {
                            return ''
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            interval: 35,
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        max: 200,
                        min: 0,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            data: this.info.hrData.split(','),
                            type: 'line',
                            showSymbol: false,
                            color: getSkin('--chart-color-3'),
                            smooth: true,
                            areaStyle: {
                                color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: 'rgba(241, 74, 97, 0)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(241, 74, 97, 0.70)',
                                    },
                                ]),
                            }
                        }
                    ]
                }, true);

                // 计算最后一个非0值并更新tooltip
                let _this = this;
                let hrDataArr = this.info.hrData.split(',');
                let xAxisData = ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00'];
                let lastIndex = -1;
                for (let i = hrDataArr.length - 1; i >= 0; i--) {
                    if (Number(hrDataArr[i]) !== 0) {
                        lastIndex = i;
                        break;
                    }
                }
                if (lastIndex >= 0) {
                    this.tooltipValue = Number(hrDataArr[lastIndex]);
                    this.tooltipTime = this.$t('vitalSigns.latest') + ' (' + xAxisData[lastIndex] + ')';
                }

                // 绑定图表点击事件，点击时更新tooltip-box
                let chartDom = document.getElementById("chart-box");
                if (this._chartClickHandler) {
                    chartDom.removeEventListener('click', this._chartClickHandler);
                }
                this._chartClickHandler = function(e) {
                    let rect = chartDom.getBoundingClientRect();
                    let x = e.clientX - rect.left;
                    let y = e.clientY - rect.top;
                    if (_this.myChart.containPixel('grid', [x, y])) {
                        let xIndex = _this.myChart.convertFromPixel({seriesIndex: 0}, [x, y])[0];
                        xIndex = Math.round(xIndex);
                        if (xIndex >= 0 && xIndex < hrDataArr.length && Number(hrDataArr[xIndex]) !== 0) {
                            _this.updateTooltip(Number(hrDataArr[xIndex]), xAxisData[xIndex]);
                        }
                    }
                };
                chartDom.addEventListener('click', this._chartClickHandler);
            }
        },
    }
}
</script>

<style scoped>

.chart-box-out {
    width: 345px;
    height: 293px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    margin: 96px auto 0;
}

.chart-title {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    color: var(--text-color-2);
    align-items: center;
    padding-top: 12px;
    margin-left: 12px;
}

.chart-title-left {
    display: flex;
    gap: 4px;
    font-size: 15px;
}

.chart-to {
    margin-right: 12px;
}

#chart-box {
    height: 173px;
    width: 100%;
}

.tooltip-box {
    text-align: center;
    margin-top: 12px;
    font-size: 0;
}

.tooltip-time {
    font-size: 13px;
    margin-bottom: 2px;
}

.tooltip-value {
    font-size: 32px;
    color: var(--text-color-1);
}

.tooltip-unit {
    font-size: 15px;
    margin-left: 4px;
}

.tooltip-safe {
    background-color: rgba(0, 189, 155, 0.2);
    color: var(--chart-color-1);
    font-size: 13px;
    border-radius: 4px;
    padding: 3px 4px;
    display: inline-block;
}

.tooltip-unsafe {
    background-color: rgba(241, 74, 97, 0.2);
    color: var(--chart-color-3);
    font-size: 13px;
    border-radius: 4px;
    padding: 3px 4px;
    display: inline-block;
}

.sign-line {
    width: 345px;
    margin: 12px auto;
    display: flex;
    justify-content: space-between;
}

.sign-item-box {
    width: 142px;
    background: var(--bg-color-2);
    border-radius: 8px 8px 8px 8px;
    padding: 12px;
    text-align: left;
    font-size: 0;
}

.tooltip-none {
    height: 19px;
}

</style>


// WEBPACK FOOTER //
// src/views/status/32vitalSigns.vue